var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "section",
    {
      staticClass: "contentbox",
    },
    [
      _c("header", [_c("h1", [_vm._v(_vm._s(_vm.$gettext("Aktivitäten")))])]),
      _vm._v(" "),
      _c(
        "section",
        [
          _c("studip-progress-indicator", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.loading,
                expression: "loading",
              },
            ],
            attrs: {
              description: _vm.$gettext("Lade Aktivitäten…"),
            },
          }),
          _vm._v(" "),
          _vm.filteredActivitiesList.length === 0 && !_vm.loading
            ? _c("courseware-companion-box", {
                attrs: {
                  mood: "sad",
                  msgCompanion: _vm.$gettext(
                    "Es wurden keine Aktivitäten gefunden."
                  ),
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _c(
            "ul",
            {
              staticClass: "cw-activities",
            },
            _vm._l(_vm.filteredActivitiesList, function (item, index) {
              return _c("courseware-activity-item", {
                key: index,
                attrs: {
                  item: item,
                },
              })
            }),
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }